import React, { FunctionComponent, HTMLAttributes } from 'react';
import Button from '../button/button-component';
import styles from './breadcrumb-component.module.scss';

export type BreadcrumbProps = {
  backArrowText?: string;
  backCallback?: () => void;
  links: {
    url: string;
    text: string;
    attributes?: {
      name: string;
      value: string;
    }[];
  }[];
} & HTMLAttributes<HTMLDivElement>;

/**
 * Breadcrumb
 *
 * https://www.figma.com/design/Op3Jr1EuRxDkL3bHKsp5qC/EM-Atoms?node-id=6795-61046&t=7uvg6FRaowyueiSK-4
 */
export const Breadcrumb: FunctionComponent<BreadcrumbProps> = (props: BreadcrumbProps) => {
  const { backArrowText, backCallback, links, className, ...divAttributes } = props;

  return (
    <div className={`${styles.container} ${className ?? ''}`} {...divAttributes}>
      {backArrowText && (
        <>
          <Button
            text={backArrowText}
            buttonType='link'
            icon='back'
            onClick={() => {
              backCallback && backCallback();
            }}
            className={styles.back}
          />
          <span className={`${styles.sep} ${styles['back-sep']}`}>|</span>
        </>
      )}
      <div className={styles['link-container']}>
        {links.map((link, i) => (
          <div className={`${styles['link-contents']} ${i === 0 || i === links.length - 1 ? styles['lte-tablet-visible'] : ''}`}>
            <Button text={link.text} buttonType='link' href={link.url} className={styles.link} />
            {i !== links.length - 1 && <span className={styles.sep}>/</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb;
